import script from "./PrintButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintButton.vue?vue&type=script&lang=ts&setup=true"

import "./PrintButton.vue?vue&type=style&index=0&id=fcd327f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcd327f0"]])

export default __exports__